import React from 'react';
import { CurrencyInput } from './CurrencyInput';
import { formatCurrency } from '../utils/currency';

export function PaymentStructure({
	cashInAdvance,
	minCashInAdvance,
	monthlyPayment,
	currency,
	startDate,
	updateFields,
}) {
	return (
		<form className="create" autoComplete="off">
			<h3>Ödeme Planını Oluştur</h3>

			<label>
				Peşin Ödenen:
				{minCashInAdvance > 0 && (
					<span className="min-hint">
						{' '}(en az {formatCurrency(minCashInAdvance, currency)})
					</span>
				)}
			</label>
			<div className="custom-input">
				<input
					type="date"
					name="date"
					value={startDate}
					onChange={(e) => updateFields({ startDate: e.target.value })}
				/>
				<CurrencyInput
					value={cashInAdvance}
					currency={currency}
					onChange={(amount) => updateFields({ cashInAdvance: amount })}
					placeholder='Örn: "10.000"'
				/>
			</div>

			<label>Aylık Ödeme:</label>
			<div className="custom-input">
				<CurrencyInput
					value={monthlyPayment}
					currency={currency}
					onChange={(amount) => updateFields({ monthlyPayment: amount })}
					placeholder='Örn: "10.000"'
				/>
			</div>
		</form>
	);
}
